// Zentrale Unternehmensdaten – hier zentral bearbeitbar.
export const company = {
  name: "Rümpeltaxi",
  legalName: "Thomas Dietrich – Rümpeltaxi",
  owner: "Thomas Dietrich",
  domain: "ruempel.taxi",
  phoneDisplay: "0151 70004440",
  phoneLink: "tel:+4915170004440",
  email: "ruempeltaxi@gmail.com",
  emailLink: "mailto:ruempeltaxi@gmail.com",
  whatsappNumber: "4915170004440",
  whatsappText:
    "Hallo Rümpeltaxi, ich interessiere mich für eine unverbindliche Anfrage und möchte gerne weitere Informationen erhalten.",
  street: "Friedenstraße 10",
  postal: "89281",
  city: "Altenstadt",
  country: "Deutschland",
  addressLines: ["Thomas Dietrich – Rümpeltaxi", "Friedenstraße 10", "89281 Altenstadt", "Deutschland"],
};

export const whatsappUrl = `https://wa.me/${company.whatsappNumber}?text=${encodeURIComponent(
  company.whatsappText
)}`;

export const nav = [
  { label: "Startseite", to: "/" },
  { label: "Leistungen", to: "/leistungen" },
  { label: "Privatkunden", to: "/privatkunden" },
  { label: "Geschäftskunden", to: "/geschaeftskunden" },
  { label: "Referenzen", to: "/referenzen" },
  { label: "Über uns", to: "/ueber-uns" },
  { label: "Einsatzgebiete", to: "/einsatzgebiete" },
  { label: "Ratgeber", to: "/ratgeber" },
  { label: "Kontakt", to: "/kontakt" },
];

// Schwerpunktregionen (Hubs) – Orientierung, keine abschließende Begrenzung.
export const regionHubs = [
  { slug: "ulm-neu-ulm", name: "Ulm, Neu-Ulm und Umgebung", short: "Ulm & Neu-Ulm" },
  { slug: "senden-voehringen", name: "Senden, Vöhringen und Umgebung", short: "Senden & Vöhringen" },
  { slug: "illertissen-allgaeu", name: "Illertissen und das Allgäu", short: "Illertissen & Allgäu" },
  { slug: "memmingen", name: "Memmingen und Umgebung", short: "Memmingen" },
  { slug: "biberach-oberschwaben", name: "Biberach und Oberschwaben", short: "Biberach" },
  { slug: "heidenheim-ostwuerttemberg", name: "Heidenheim und Ostwürttemberg", short: "Heidenheim" },
  { slug: "guenzburg", name: "Günzburg und westliches Bayern", short: "Günzburg" },
  { slug: "goeppingen-filstal", name: "Göppingen und das Filstal", short: "Göppingen" },
  { slug: "ulm-stuttgart", name: "Region zwischen Ulm und Stuttgart", short: "Ulm–Stuttgart" },
  { slug: "stuttgart", name: "Stuttgart und Umgebung", short: "Stuttgart" },
  { slug: "ludwigsburg-bietigheim", name: "Landkreis Ludwigsburg & Bietigheim", short: "Ludwigsburg" },
  { slug: "heilbronn", name: "Stadt- und Landkreis Heilbronn", short: "Heilbronn" },
];

export const trustPoints = [
  "Persönliche Ansprechpartner",
  "Transparente Angebotserstellung",
  "Sorgfältige Durchführung",
  "Auf Wunsch besenreine Übergabe",
];

export const serviceOptions = [
  "Entrümpelung",
  "Haushaltsauflösung",
  "Wohnungsauflösung",
  "Nachlassauflösung",
  "Gewerbeauflösung",
  "Keller oder Dachboden",
  "Entsorgung",
  "Umzug",
  "Möbelmontage",
  "Einlagerung",
  "Sonstiges",
];
